import { render, staticRenderFns } from "./FormularioTipoTratamiento.vue?vue&type=template&id=174a8f6a&scoped=true"
import script from "./FormularioTipoTratamiento.vue?vue&type=script&lang=js"
export * from "./FormularioTipoTratamiento.vue?vue&type=script&lang=js"
import style0 from "./FormularioTipoTratamiento.vue?vue&type=style&index=0&id=174a8f6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174a8f6a",
  null
  
)

export default component.exports